import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { clearAuthAndRedirect } from '@/entities/Admin';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import {
  GET_USERS,
  GET_USER,
  GET_CATEGORIES,
  GET_CATEGORY,
  GET_TEACHERS,
  GET_TEACHER,
  GET_ADMINISTRATORS,
  GET_ADMINISTRATOR,
  GET_COURSES,
  GET_COURSE,
  GET_LESSONS,
  GET_INVOICES,
  GET_PAYMENTS,
  GET_PAYMENT,
  GET_HUBSPOT_CONTACTS,
  GET_FINANCE_SUMMARY,
  GET_FINANCE_HEALTH,
  GET_FINANCE_REPORTS,
  GET_BADGES_LEADERBOARD,
  GET_BADGES,
  GET_BADGE_RECIPIENTS,
  GET_HOMEWORKS,
  GET_HOMEWORK,
  GET_NOTIFICATIONS,
  GET_MY_NOTIFICATIONS,
  GET_MY_NOTIFICATIONS_UNREAD_COUNT,
  GET_EMAIL_NOTIFICATIONS,
  GET_EVENTS,
  GET_EVENT,
  GET_REVIEWS,
  GET_REVIEW,
  GET_DASHBOARD,
  GET_ADMIN,
  GET_STUDENTS,
  GET_STUDENT,
  GET_USER_NOTES,
  GET_APPLICANTS,
  GET_USER_ACTIVITIES,
  GET_APPLICATIONS,
  GET_APPLICATIONS_COUNT,
  GET_APPLICATION,
  GET_ACADEMIC_STAFF,
  GET_ASSIGNMENTS,
  GET_CERTIFICATES_COURSES,
  GET_CERTIFICATES_BY_COURSE,
  GET_CERTIFICATES_SIGNATURE,
  GET_ADMIN_ROLES,
  GET_ADMIN_ROLE_STAFF,
  GET_ADMIN_DEPARTMENTS,
  GET_MY_ADMIN_ACCESS,
  GET_LOCATIONS,
  GET_TAGS,
  GET_REPORTS,
  GET_CALENDAR,
  GET_ATTENDANCE,
  GET_NEWS,
  GET_BLOGS,
  GET_ACCOUNT_DELETIONS,
} from './tags';

const baseQuery = fetchBaseQuery({
  baseUrl: __API__,
  credentials: 'include',
  prepareHeaders: (headers) => {
    const accessToken = LocalStorageService.getAccessToken();
    if (accessToken) {
      headers.set('Authorization', `Bearer ${accessToken}`);
    }
    headers.set('Accept', 'application/json');
    // НЕ устанавливаем Content-Type здесь - это будет сделано в fetchFn
    // Для FormData браузер установит multipart/form-data автоматически
    return headers;
  },
  fetchFn: async (input, init) => {
    const request = input instanceof Request ? input : undefined;
    const headers = new Headers(init?.headers ?? request?.headers);
    const accessToken = LocalStorageService.getAccessToken();
    if (accessToken) {
      headers.set('Authorization', `Bearer ${accessToken}`);
    }
    headers.set('Accept', 'application/json');

    const body = init?.body;
    const isFormDataBody =
      body instanceof FormData || Object.prototype.toString.call(body) === '[object FormData]';
    const isMultipart = (headers.get('Content-Type') || '').toLowerCase().includes('multipart/form-data');

    if (isFormDataBody) {
      headers.delete('Content-Type');
    } else if (!isMultipart) {
      headers.set('Content-Type', 'application/json');
    }

    return fetch(input, {
      ...init,
      headers,
    });
  },
});

export const baseQueryWithInterceptor = async (args: any, api: any, extraOptions: any) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error) {
    if (result.error.status === 401) {
      clearAuthAndRedirect('/login');
    } else if (result.error.status === 403) {
      const accessToken = LocalStorageService.getAccessToken();
      if (!accessToken) {
        clearAuthAndRedirect('/login');
      }
    }
  }

  return result;
};

export const rtkApi = createApi({
  reducerPath: 'api',
  tagTypes: [
    GET_ADMIN,
    GET_USERS,
    GET_USER,
    GET_CATEGORIES,
    GET_CATEGORY,
    GET_TEACHERS,
    GET_TEACHER,
    GET_ADMINISTRATORS,
    GET_ADMINISTRATOR,
    GET_COURSE,
    GET_COURSES,
    GET_LESSONS,
    GET_INVOICES,
    GET_PAYMENTS,
    GET_PAYMENT,
    GET_HUBSPOT_CONTACTS,
    GET_FINANCE_SUMMARY,
    GET_FINANCE_HEALTH,
    GET_FINANCE_REPORTS,
    GET_BADGES_LEADERBOARD,
    GET_BADGES,
    GET_BADGE_RECIPIENTS,
    GET_HOMEWORKS,
    GET_HOMEWORK,
    GET_NOTIFICATIONS,
    GET_MY_NOTIFICATIONS,
    GET_MY_NOTIFICATIONS_UNREAD_COUNT,
    GET_EMAIL_NOTIFICATIONS,
    GET_EVENTS,
    GET_EVENT,
    GET_REVIEWS,
    GET_REVIEW,
    GET_DASHBOARD,
    GET_STUDENTS,
    GET_STUDENT,
    GET_USER_NOTES,
    GET_APPLICANTS,
    GET_USER_ACTIVITIES,
    GET_APPLICATIONS,
    GET_APPLICATIONS_COUNT,
    GET_APPLICATION,
    GET_ACADEMIC_STAFF,
    GET_ASSIGNMENTS,
    GET_CERTIFICATES_COURSES,
    GET_CERTIFICATES_BY_COURSE,
    GET_CERTIFICATES_SIGNATURE,
    GET_ADMIN_ROLES,
    GET_ADMIN_ROLE_STAFF,
    GET_ADMIN_DEPARTMENTS,
    GET_MY_ADMIN_ACCESS,
    GET_LOCATIONS,
    GET_TAGS,
    GET_REPORTS,
    GET_CALENDAR,
    GET_ATTENDANCE,
    GET_NEWS,
    GET_BLOGS,
    GET_ACCOUNT_DELETIONS,
  ],
  baseQuery: baseQueryWithInterceptor,
  endpoints: () => ({}),
});
